import currency from '@/filters/currency'
export default currency
